import { useSelector } from 'react-redux'

import { selectUserScid } from 'store/user'

export default () => useSelector(selectUserScid)
